import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GuiFlowService } from 'src/app/___LOGIC/__gui/gui-flow.service';

@Component({
  selector: 'app-loading-modal',
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.css']
})
export class LoadingModalComponent implements OnInit {

  @Input() isVisible;
  @Input() modalType;
  @Input() showSpinner;
  @Input() message: string;
  @Input() scrollTarget: string; // e.g. 'my-section'
  @Input() autoCloseAfter = 0; // time in ms (0 = manual)

  @Output() closed = new EventEmitter();

  constructor(private guiFlow: GuiFlowService){
    if(this.isVisible == null){
      this.isVisible = this.guiFlow.isLoadingModalVisible();
    }
    if(this.message == null){
      this.message = this.guiFlow.getModalInfo('message');
    }
    if(this.modalType == null){
      this.modalType = this.guiFlow.getModalInfo('modalType');
    }
  }
  
  ngOnInit(): void {}

  isModalVisible(){
    return this.isVisible || this.guiFlow.isLoadingModalVisible();
  }

  renderMessage(){
    return this.guiFlow.getModalInfo('message');
  }

  getModalType(){
    return this.guiFlow.getModalInfo('modalType');
  }

  ngOnChanges(): void {
    if (this.isModalVisible() && this.autoCloseAfter > 0) {
      setTimeout(() => {
        this.close();
      }, this.autoCloseAfter);
    }else{
      
    }
  }

  close() {
    this.isVisible = false;
    this.closed.emit(this.scrollTarget);

    if (this.scrollTarget) {
      setTimeout(() => {
        const element = document.querySelector(`#${this.scrollTarget}`);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100); // delay to let modal fade
    }
  }
}